const securekey = 'ksfjklj093492409kjklfj09230923409jflsjfjiou0923fjksjf394930480329n';

export default securekey;
